module.exports = __webpack_public_path__ + "img/part.decd220b.svg";